export const initialState = {
  featuredList: [],
  userSubLanguage: {
    languageCode: null,
    srtUrl: null,
  },
};
